module.exports = __webpack_public_path__ + "static/media/15A.fc8ddf18.png";